
import React, {
  useState,
  useEffect,
  useCallback,
  useReducer,
  useContext,
} from "react";
import getUrl from "../function/getUrl.js"
import FunBarClass from "./funBarClass.js";
import { Link, useParams } from "react-router-dom";
import getDay from "../function/getDay.js"
import dateDiff from "../function/dateDiff.js"
import checkLogin from "../function/checkLogin.js"
import checkLevel from "../function/checkLevel.js"

const url = getUrl()
const token = sessionStorage.getItem("token")
//課程銷售
const OrderAdd = () => {
  //銷售後 要同步調整 學員身分別
  // 體驗銷售 不得銷售給 正式學員
  //非本人時且權限為1時，不得更改密碼
  checkLogin()
  let param = useParams(); //功能項目
  let studentDBID = param.studentDBID;
  console.log("studentDBID", studentDBID)
  const today = getDay(0, "-")
  console.log("today", today)
  const operator = sessionStorage.getItem("staffDBID")
  const [salesEvent, setSalesEvent] = useState([])
  const [studentData, setStudentData] = useState({})

  const orderAmountNumber=["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26"]

  

  

  const orderInit={
      studentDBID:studentDBID,
      eventDBID:"",
      orderDate:today,
      eventName:"",
      elpOrder:"false",
      classAmount:0,
      classDays:0,
      eventPrice:0,
      classStartDate:today,
      payment:"信用卡",
      amount:1,
      total:0,
      memo:"",
      operator:operator,
      invoiceID:"",
      salesItemClassDays:0,
      tax:0,
      classEndDate:"",


  }
     
  const reducer = (state, action) => {
    switch (action.type) {
      case "studentDBID":
        return { ...state, studentDBID: action.value };
      case "eventDBID":
        return { ...state, eventDBID: action.value };
      case "orderDate":
        return { ...state, orderDate: action.value };
      case "eventName":
        return { ...state, eventName: action.value };
      case "elpOrder":    
        return { ...state, elpOrder: action.value };
      case "classAmount":
        return { ...state, classAmount: action.value };
      case "classDays":
        return { ...state, classDays: action.value };
      case "eventPrice":
        return { ...state, eventPrice: action.value };
      case "classStartDate":
        return { ...state, classStartDate: action.value };
      case "payment":
        return { ...state, payment: action.value };
      case "amount":
        return { ...state, amount: action.value };
      case "total":
        return { ...state, total: action.value };
      case "memo":
        return { ...state, memo: action.value };
      case "operator":
        return { ...state, operator: action.value };
      case "invoiceID":
        return { ...state, invoiceID: action.value };
      case "salesItemClassDays":
        return { ...state, salesItemClassDays: Number(action.value) };
      case "tax":
        return { ...state, tax: action.value };
      case "classEndDate":
        return { ...state, classEndDate: action.value };
      case "reset":
        return orderInit;   

      default:
        return state;
    }
  };
  const [state, dispatch] = useReducer(reducer, orderInit);
 


const changeEndDate=()=>{
  //計算終止日
   console.log("計算終止日")
      let classDays=Number(state.classDays)
      let startDate=state.classStartDate
      
      let tempDate=new Date(startDate)
      console.log("startDate",startDate,classDays)
      console.log(tempDate,tempDate.getDate())
      let classEndDate=new Date(tempDate.setDate(tempDate.getDate() + parseInt(classDays,"10")))
      console.log(classEndDate,classEndDate.getFullYear(),classEndDate.getMonth()+1,classEndDate.getDate())
      dispatch({type:"classEndDate", value:`${classEndDate.getFullYear()}-${(classEndDate.getMonth()+1).toString().padStart(2,"0")}-${classEndDate.getDate().toString().padStart(2,"0")}`})
      
}

  
 

  useEffect(() => {

    
    const setStudent = async (studentDBID) => {
      let student = await fetchStudentData(studentDBID)
      console.log("student", student)
      let studentLastDate= await fetchStudentLastDate(studentDBID)
      console.log("studentLastDate", studentLastDate)
      student.studentLastDate=studentLastDate
      setStudentData(student)
     
    }
    const setSales=async()=>{
      let events= await fetchSalesEvent()
      console.log("events",events)
      setSalesEvent(events)
      
    }
      
    dispatch({type:"classStartDate", value:today})
    dispatch({type:"orderDate", value:today})
    
    setStudent(studentDBID)
    setSales()
  }, [])

  function handelSummit(e) {
    let saleItem=salesEvent.find(item=>{
      return item.eventDBID==document.getElementById('eventSelected').value
    })

    // alert(saleItem.forELP)

    let invoiceID=document.getElementById("invoiceID").value
    if (invoiceID==""){
      alert ('發票號碼未填寫')
      return
    }
    let startDate=document.getElementById('classStartDate').value
    let newStartDate=startDate.toString().replaceAll("-","/")
    console.log("newStartDate",newStartDate)
      console.log(saleItem.eventDBID)
      var formData = new FormData();

      formData.append("studentDBID", state.studentDBID);
      formData.append("eventDBID", state.eventDBID);
      formData.append("orderDate", state.orderDate);
      formData.append("eventName", state.eventName);
      // formData.append("classAmount", saleItem.classAmount);
      formData.append("classAmount", state.classAmount);
      // formData.append("classDays", saleItem.classDays);
      formData.append("classDays", state.classDays)
      formData.append("elpOrder",state.elpOrder);//判斷是否為水流機訂單
      formData.append("eventPrice", state.eventPrice);
      formData.append("classStartDate", state.classStartDate);
      formData.append("payment", state.payment);
      formData.append("amount", state.amount);
      // formData.append("classDays",  saleItem.classDays*document.getElementById("amount").value);
      formData.append("memo", state.memo);
      formData.append("total", state.total);
      formData.append("operator", state.operator);
      formData.append("invoiceID", state.invoiceID);
      formData.append("token", token);
      console.log(state)
      console.log("formData", formData)

      fetch(`${url}/appPost/addNewOrder`, {
        method: "POST",
        body: formData,
        mode: "cors",
      })
        .then((res) => {
          
          window.location.href = `/SingleStudentView/${studentDBID}`
         

        }).then(() => {
          // window.location.href = `/SingleStudentView/${studentDBID}`
        })

      // return window.location.href = `/SingleStudentView/${studentDBID}`
  }

useEffect(() => {
  console.log("eventName changed", state.eventName)
  let saleItem=salesEvent.find(item=>{
    return item.eventDBID==state.eventDBID
  })

  if (saleItem && state.eventDBID){
   
  console.log("saleItem",saleItem)
  // 移除重複的 eventDBID dispatch 避免無限循環
  dispatch({type:"eventName", value:saleItem.eventName})
  dispatch({type:"elpOrder", value:saleItem.forELP})
  dispatch({type:"classAmount", value:Number(saleItem.classAmount)*Number(state.amount)})
  dispatch({type:"classDays", value:Number(saleItem.classDays)*Number(state.amount)})
  dispatch({type:"eventPrice", value:saleItem.eventPrice})
  dispatch({type:"salesItemClassDays", value:Number(saleItem.classDays)})
  let total=parseInt(state.amount,"10")*(parseInt(saleItem.eventPrice,"10"))
  dispatch({type:"total", value:total})
  let tax= Math.round(total*0.05)
  dispatch({type:"tax", value:tax})
  }

},[state.eventDBID,state.amount,salesEvent])

useEffect(() => {
  console.log("classDays changed", state.classDays)
  changeEndDate()
},[state.classDays,state.classStartDate])

  return (
    <>

      <div className="container vw-100 " style={{ maxWidth: "500px" }}>
        <div className="card bg-info text-white p-2">
          <h5 className="m-1" id="title">新增 {studentData?.name} 課程訂單</h5>
        </div>
        <div className="mt-2">
          <div className="card mt-2 ">
            <div className="card-header alert-info">基本資料區</div>

            <div className="m-1">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-info"
                    id="validationTooltipUsernamePrepend"
                  >
                    姓名
                      </span>
                </div>
                <div

                  id="name"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >
                 {studentData?.name}
                </div>
               
              </div>
            </div>

            <div className="m-1">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-info"
                    id="validationTooltipUsernamePrepend"
                  >
                    暱稱
                      </span>
                </div>
                <div

                  id="nickName"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >
                  {studentData?.nickName}
                </div>
              </div>
            </div>

            <div className="m-1">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-info"
                    id="validationTooltipUsernamePrepend"
                  >
                    家長
                      </span>
                </div>
                <div

                  id="parent"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >{studentData?.parent}
                </div>
              </div>
            </div>
            <div className="m-1">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-info"
                    id="validationTooltipUsernamePrepend"
                  >
                  目前有效期限
                      </span>
                </div>
                <div

                  id="lastDate"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >{studentData?.studentLastDate}</div>
              </div>
            </div>

          </div>

          <div className="card  mt-2 " style={{ width: "100%" }}>
            <div className="card-header alert-warning">訂單資料區</div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    訂單日期
                      </span>
                </div>
                <input
                  type="date"
                  id="orderDate"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"
                  value={state.orderDate}
                  onChange={(e)=>{
                    dispatch({type:"orderDate", value:e.target.value})

                  }}
                />
              </div>
            </div>

            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    專案名稱
                      </span>
                </div>
                <select id="eventSelected" className="custom-select" required 
                onChange={(e)=>{

                  dispatch({type:"eventDBID", value:e.target.value})
                }}
                value={state.eventDBID}
                >
                  <option value="">請選擇專案</option>
                  {salesEvent.map((item,index)=>{
                   if(item.forMember=="true"){
                    return (
                      <option key={index} value={item.eventDBID}>{item.eventName}</option>
                    )
                   }else{
                     return null
                   }
                  })}
                </select>
              </div>
            </div>

            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    訂購數量
                      </span>
                </div>
                <select id="amount" className="custom-select" required 
                onChange={(e)=>{
                  let amount=e.target.value
                  dispatch({type:"amount", value:amount})
                 
                }}
                value={state.amount}
                >
                  {orderAmountNumber.map((item, index)=>{
                    return  <option key={index} value={parseInt(item,"10")}>{item}</option>
                  })}
                  
                </select>
              </div>
            </div>

            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    專案堂數
                      </span>
                </div>
              <div

                 
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >{state.classAmount}
                </div>
              </div>
            </div>

            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    課程天數
                      </span>
                </div>
               
           <div

                 
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >{state.classDays} 
                </div>
              </div>
            </div>

            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    專案單價
                      </span>
                </div>
                 <div

                 
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >{state.eventPrice}
                </div>
              </div>

              <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    訂單總金額
                      </span>
                </div>
               <div

                 
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                >{state.total}
                </div>
              </div>
            </div>

            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    未稅/稅金
                      </span>
                </div>
                <div
                  id="taxPrice"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"
                
                >
                未稅：{state.total * 0.95} / 稅金：{state.tax}</div>
              </div>
            </div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    發票號碼
                      </span>
                </div>
                <input
                  type="text"
                  id="invoiceID"
                  className="form-control"
                  value={state.invoiceID}
                  aria-describedby="validationTooltipUsernamePrepend"
                  onChange={(e)=>{
                    dispatch({type:"invoiceID", value:e.target.value})
                  }}
                />

              </div>
            </div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    付款方式
                      </span>
                </div>
                <select id="payment" className="custom-select" required 
                onChange={(e)=>{
                  dispatch({type:"payment", value:e.target.value})
                }}
                value={state.payment}
               >
                  <option value="信用卡">信用卡</option>
                  <option value="現金">現金</option>
                  <option value="匯款">匯款</option>
                  <option value="贈課">贈課</option>
                  <option value="其他">其他</option>
                </select>
              </div>
            </div>
            </div>
          </div>

          <div className="card  mt-2 " style={{ width: "100%" }}>
            <div className="card-header alert-danger">課程資料區</div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-danger"
                    id="validationTooltipUsernamePrepend"
                  >
                    課程啟用日期
                      </span>
                </div>
                <input
                  type="date"
                  id="classStartDate"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"
                  
                  value={state.classStartDate}
                  onChange={(e)=>{
                    //課程啟始日 不得高過簽約orderDate30天
                    let orderDateMaxValue = new Date(state.orderDate)
                    orderDateMaxValue.setDate(orderDateMaxValue.getDate() + 30)
                    console.log("orderDateMaxValue",orderDateMaxValue)
                    if (new Date(e.target.value)>orderDateMaxValue){
                      alert("課程啟始日 不得高過簽約日30天")
                      dispatch({type:"classStartDate", value:today})

                    }else{
                      dispatch({type:"classStartDate", value:e.target.value})
                    
                    }
                    
                  }}
                />
              </div>
            </div>

           
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-danger"
                    id="validationTooltipUsernamePrepend"
                  >
                    課程到期日
                      </span>
                </div>
                <div
                 
                  id="classEndDate"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"
                
                >{state.classEndDate} </div>
              </div>
            </div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-danger"
                    id="validationTooltipUsernamePrepend"
                  >
                    訂單備註
                      </span>
                </div>
                <input
                  type="text"
                  id="memo"
                  className="form-control"
                 
                  aria-describedby="validationTooltipUsernamePrepend"
                  value={state.memo}
                  onChange={(e)=>{
                    dispatch({type:"memo", value:e.target.value})
                  }}
                />

              </div>
            </div>
          </div>

          <div className="card  mt-2 p-1" style={{ width: "100%" }}>
            <button
              type="button"
              onClick={handelSummit}
              className="btn btn-danger "
              disabled={state.eventDBID==""?true:false}
            >
              新增訂單
                </button>
            <Link to={`/SingleStudentView/${studentDBID}`}>
              <div
                className="btn alert-dark mt-1" style={{ width: "100%" }}
              >
                取消
                  </div>
            </Link>
          </div>

        </div>
      </div>
    </>
  )

};



export default OrderAdd;


const fetchSalesEvent=async()=>{
    const token = sessionStorage.getItem("token")
    return fetch(`${url}/appGet/getSalesEvent?token=${token}`).then((res) => {
      return res.json()
    }).then((json) => {
     
      json.map((item,index)=>{
        json[index].eventPrince=parseInt(json[index].eventPrince,"10")
      })

      json.sort((a,b)=>{
        var nameA = a.eventPrince; 
        var nameB = b.eventPrince; 
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
      return 0;
      })
      console.log(json)
     

     
      // eventOption[0].selected = true;
      return json
      
    }).catch((e) => {
      alert('伺服器錯誤')
    })
  }


  const fetchStudentData = async(studentDBID) => {
   
    return fetch(`${url}/appGet/singleStudentView?studentDBID=${studentDBID}&token=${token}`).then((res) => {
      return res.json()
    }).then((json) => {
      //設置 student Data
      return json
      console.log(json)
    }).catch((e) => {
      alert('伺服器錯誤')
    })
  }

  const fetchStudentLastDate=async(studentDBID)=>{
    
    return fetch(`${url}/appGet/getStudentLastDate?studentDBID=${studentDBID}&token=${token}`).then((res) => {
      return res.json()
    }).then((json) => {
      
      console.log(json)
      if (json[0]==null){
        return ""
      }
      return json[0].lastDate
      
    }).catch((e) => {
      alert('伺服器錯誤')
    })
  }